module.exports = __webpack_public_path__ + "img/object-mark8.2ab4b7ac.png";